<template>
  <component
    :is="icon"
    v-if="icon"
    class="dn-icon"
  />
</template>
<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
const props = defineProps({
  /**
   * Svg src
   * @param {String} value = svgUrl
   */
  name: {
    type: String,
    required: true,
    default: null
  }
});
const iconList = import.meta.glob('@/assets/svg/**/*.svg');
const icon = computed(() => {
  return iconList[`/assets/svg/${props.name}.svg`] ? defineAsyncComponent(() => iconList[`/assets/svg/${props.name}.svg`]()) : false;
});
</script>
<style lang="scss">
.dn-icon {
  padding: 0;
  margin: 0;

  --_dn-icon_color: var(--dn-icon_color, #090909);

  &.pulsating {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;

    &::before, &::after {
      content: '';
      display: flex;
      flex: 0 0 calc(100% - 5px);
      will-change: transform;
      transform-origin: center;
      width: calc(100% - 5px);
      height: calc(100% - 5px);
      border-radius: 100%;
    }

    &::before {
      background-color: var(--_dn-icon_color);
      animation: pulsate 2.25s ease-in-out infinite;
    }

    &::after {
      position: absolute;
      border: 1px solid var(--_dn-icon_color);
      animation: pulsate2 2.25s ease-in-out infinite;
    }
  }

  /* Keyframe Animation for Pulsing Effect */
  @keyframes pulsate {
    0% {
      transform: scale(0.3);
    }

    50% {
      transform: scale(0.45); /* 120% size */
    }

    70% {
      transform: scale(0.3);
    }

    100% {
      transform: scale(0.3);
    }
  }

  @keyframes pulsate2 {
    0% {
      transform: scale(0.1);
    }

    50% {
      opacity: 1;
    }

    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
}
</style>
